import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  query,
  orderBy
} from "firebase/firestore";
import { db } from "../../../firebase/firestore.js";
import { auth } from "../../../firebase/auth.js";

const COLLECTION_NAME = "items";

function normalizeDoc(id, data) {
  return {
    id,
    itemName: data.itemName || data.name || "",
    name: data.itemName || data.name || "",
    itemType: data.itemType || "goods",
    gstCode: data.gstCode || data.sku || "",
    sku: data.gstCode || data.sku || "",
    gstPercent: Number(data.gstPercent !== undefined ? data.gstPercent : 18),
    basicPrice: Number(data.basicPrice !== undefined ? data.basicPrice : (data.sellingPrice || data.price || 0)),
    sellingPrice: Number(data.basicPrice !== undefined ? data.basicPrice : (data.sellingPrice || data.price || 0)),
    costPrice: Number(data.costPrice || 0),
    stock: Number(data.stock || 0),
    reorderLevel: Number(data.reorderLevel || 10),
    unit: data.unit || "pcs",
    status: data.status || "active",
    companyIds: Array.isArray(data.companyIds) ? data.companyIds : [],
    createdAt: data.createdAt,
    updatedAt: data.updatedAt
  };
}

// CREATE
export async function createItem(itemData) {
  const payload = {
    itemName: itemData.itemName || itemData.name || "",
    itemType: itemData.itemType || "goods",
    gstCode: itemData.gstCode || itemData.sku || "",
    gstPercent: Number(itemData.gstPercent !== undefined ? itemData.gstPercent : 18),
    basicPrice: Number(itemData.basicPrice !== undefined ? itemData.basicPrice : (itemData.sellingPrice || itemData.price || 0)),
    costPrice: Number(itemData.costPrice || 0),
    stock: Number(itemData.stock || 0),
    reorderLevel: Number(itemData.reorderLevel || 10),
    unit: itemData.unit || "pcs",
    status: itemData.status || "active",
    companyIds: Array.isArray(itemData.companyIds) ? itemData.companyIds : [],
    createdBy: auth.currentUser?.email || auth.currentUser?.uid || "admin",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const itemsRef = collection(db, COLLECTION_NAME);
  const docRef = await addDoc(itemsRef, payload);
  return docRef.id;
}

// READ
export async function getItems() {
  const itemsRef = collection(db, COLLECTION_NAME);
  try {
    const q = query(itemsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => normalizeDoc(doc.id, doc.data()));
  } catch (_) {
    const snapshot = await getDocs(itemsRef);
    return snapshot.docs.map((doc) => normalizeDoc(doc.id, doc.data()));
  }
}

// UPDATE
export async function updateItem(id, itemData) {
  const payload = {
    itemName: itemData.itemName || itemData.name || "",
    itemType: itemData.itemType || "goods",
    gstCode: itemData.gstCode || itemData.sku || "",
    gstPercent: Number(itemData.gstPercent !== undefined ? itemData.gstPercent : 18),
    basicPrice: Number(itemData.basicPrice !== undefined ? itemData.basicPrice : (itemData.sellingPrice || itemData.price || 0)),
    costPrice: Number(itemData.costPrice || 0),
    stock: Number(itemData.stock || 0),
    reorderLevel: Number(itemData.reorderLevel || 10),
    unit: itemData.unit || "pcs",
    status: itemData.status || "active",
    updatedAt: serverTimestamp()
  };

  if (itemData.companyIds !== undefined) {
    payload.companyIds = Array.isArray(itemData.companyIds) ? itemData.companyIds : [];
  }

  const itemRef = doc(db, COLLECTION_NAME, id);
  await updateDoc(itemRef, payload);
}

// DELETE
export async function deleteItem(id) {
  const itemRef = doc(db, COLLECTION_NAME, id);
  await deleteDoc(itemRef);
}
